__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "webapp";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@amx/core-1ds", "0.1.25128002", () => (Promise.all([__webpack_require__.e(19), __webpack_require__.e(114), __webpack_require__.e(564)]).then(() => (() => (__webpack_require__(9114))))));
			register("@amx/core-client-telemetry", "0.1.25128002", () => (Promise.all([__webpack_require__.e(19), __webpack_require__.e(440), __webpack_require__.e(682), __webpack_require__.e(336), __webpack_require__.e(822), __webpack_require__.e(301), __webpack_require__.e(689), __webpack_require__.e(343), __webpack_require__.e(663)]).then(() => (() => (__webpack_require__(4336))))));
			register("@amx/core-portal-telemetry", "0.1.25128002", () => (Promise.all([__webpack_require__.e(19), __webpack_require__.e(763)]).then(() => (() => (__webpack_require__(9763))))));
			register("@amx/ux-twoui-telemetry", "10.1.0", () => (Promise.all([__webpack_require__.e(440), __webpack_require__.e(822), __webpack_require__.e(301), __webpack_require__.e(999)]).then(() => (() => (__webpack_require__(2131))))));
			register("@amx/ux-twoui", "10.1.0", () => (Promise.all([__webpack_require__.e(440), __webpack_require__.e(932), __webpack_require__.e(223), __webpack_require__.e(822), __webpack_require__.e(301), __webpack_require__.e(689), __webpack_require__.e(901), __webpack_require__.e(44), __webpack_require__.e(477)]).then(() => (() => (__webpack_require__(5223))))));
			register("axios", "1.18.1", () => (Promise.all([__webpack_require__.e(414), __webpack_require__.e(987)]).then(() => (() => (__webpack_require__(6414))))));
			register("react-dom", "16.14.0", () => (Promise.all([__webpack_require__.e(224), __webpack_require__.e(822)]).then(() => (() => (__webpack_require__(7224))))));
			register("react-redux", "7.2.9", () => (Promise.all([__webpack_require__.e(991), __webpack_require__.e(278), __webpack_require__.e(184)]).then(() => (() => (__webpack_require__(6991))))));
			register("react-router-dom", "5.3.4", () => (Promise.all([__webpack_require__.e(441), __webpack_require__.e(668)]).then(() => (() => (__webpack_require__(5822))))));
			register("react", "16.14.0", () => (__webpack_require__.e(953).then(() => (() => (__webpack_require__(4953))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};